//utilties
import { BuildPath } from "@/helpers/Paths";

//interfaces
import { Direction, IDirectionalToggle, SortBy } from "../../../../../interfaces/toggle";


const UseDirectionalToggle = ({direction, sortAscending, sortDescending, defaultSort, onRemoveDefaultSort} : IDirectionalToggle) => {

    const directionOrDefault = () => {
        if(defaultSort && !direction) {
            return defaultSort === SortBy.ASCENDING ? Direction.UP : Direction.DOWN
        }else if (!defaultSort && !direction) {
            return Direction.BOTH
        }else {
            return direction
        }
    }

    const handleClick = () => {
        onRemoveDefaultSort?.();
        if (directionOrDefault() === Direction.DOWN) {
            sortAscending();
        } else {
            sortDescending();
        }
    };

    const getAriaLabel = () => {
        if (directionOrDefault() === Direction.DOWN) {
            return "Sort ascending";
        } else {
            return "Sort descending";
        }
    };

    const getImageSrc = () => {
        if (directionOrDefault() === Direction.DOWN) {
            return `${BuildPath()}/images/toggle/sort-down.svg`;
        } else if (directionOrDefault() === Direction.UP) {
            return `${BuildPath()}/images/toggle/sort-up.svg`;
        } else {
            return `${BuildPath()}/images/toggle/sort-off.svg`;
        }
    };

    return {handleClick, getAriaLabel, getImageSrc};
};

export default UseDirectionalToggle;